import { defineComponent as l, ref as s, openBlock as f, createBlock as o, unref as d, withCtx as r, renderSlot as m, nextTick as y } from "vue";
import "./ghl-ui.es195.js";
import c from "./ghl-ui.es196.js";
const p = l({
  name: "UITabs",
  inheritAttrs: !1
}), v = l({
  ...p,
  props: {
    value: {
      type: [String, Number]
    },
    type: {
      type: String,
      default: "line"
    },
    defaultValue: {
      type: String,
      default: void 0
    },
    justifyContent: {
      type: String,
      default: ""
    },
    animated: {
      type: Boolean,
      default: !1
    },
    placement: {
      type: String,
      default: "top"
    },
    size: {
      type: String,
      default: "medium"
    }
  },
  emits: ["update:value"],
  setup(e, { expose: u }) {
    const a = s(null);
    return u({ syncBarPosition: () => {
      y(() => {
        var t;
        return (t = a.value) == null ? void 0 : t.syncBarPosition();
      });
    } }), (t, n) => (f(), o(d(c), {
      ref_key: "tabsInstRef",
      ref: a,
      value: e.value,
      "onUpdate:value": n[0] || (n[0] = (i) => t.$emit("update:value", i)),
      type: e.type,
      animated: e.animated,
      placement: e.placement,
      "justify-content": e.justifyContent,
      "default-value": e.defaultValue,
      size: e.size,
      class: "hl-tabs"
    }, {
      default: r(() => [
        m(t.$slots, "default")
      ]),
      _: 3
    }, 8, ["value", "type", "animated", "placement", "justify-content", "default-value", "size"]));
  }
}), j = v;
export {
  j as default
};
